"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CartZipEditState_1 = require("./CartZipEditState");
var localStyles = require("./CartZipEdit.scss");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var CartUtilFunctions_1 = require("../../../../utils/CartUtilFunctions");
var CartConfiguration_scss_1 = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var icons = require("../../../../styles/ccc-icons-cart.scss");
var ReportingService_1 = require("../../../../api/ReportingService");
var StateProvider_1 = require("../../../../api/StateProvider");
var Api_1 = require("../../../../api/Api");
var Utils = require("../../../../utils/UtilityFunctions");
var TextFieldProps_1 = require("@idp/ui-components/components/atoms/TextField/TextFieldProps");
var ButtonProps_1 = require("@idp/ui-components/components/atoms/Button/ButtonProps");
var components_1 = require("@idp/duc/components");
var CartCommon_scss_1 = require("../../../../styles/CartCommon.scss");
var InsuranceModel_1 = require("../../shared/InsuranceModel/InsuranceModel");
var WirelessCart_cms_1 = require("../../../../components/CartLob/WirelessCart/WirelessCart.cms");
var Cart_cms_1 = require("../../../../cms/Cart.cms");
var cms_integration_1 = require("@idp/cms-integration");
var CartZipEdit = /** @class */ (function (_super) {
    __extends(CartZipEdit, _super);
    function CartZipEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.NUM_ONLY_REGEX = new RegExp('^[0-9]*$');
        _this.zipCodeUpdateModal = 'CART:zipUpdate';
        _this.state = new CartZipEditState_1.default();
        _this.bindAll();
        _this.api = new Api_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        return _this;
    }
    CartZipEdit.prototype.bindAll = function () {
        this.displayZipEdit = this.displayZipEdit.bind(this);
        this.toggleZipEdit = this.toggleZipEdit.bind(this);
        this.displayZipEditField = this.displayZipEditField.bind(this);
        this.setZipCodeValues = this.setZipCodeValues.bind(this);
        this.performZipCodeAction = this.performZipCodeAction.bind(this);
        this.initializeZipCodeEvents();
    };
    CartZipEdit.prototype.componentDidMount = function () {
        var _a;
        var payload = Utils.getCartResp();
        var cookieUpdateRequired = (_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.cookieUpdateRequired;
        if (cookieUpdateRequired) {
            this.submitZipCode(true);
        }
    };
    CartZipEdit.prototype.render = function () {
        var cmsData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content;
        var showModal = this.state.showInsuranceModal || CartUtilFunctions_1.getZipChangeModalStatus();
        if (cmsData && cmsData.wirelessCart.cartSummary) {
            this.cmsContent = cmsData.wirelessCart.cartSummary;
        }
        else {
            this.cmsContent = new WirelessCart_cms_1.WirelessCartSummaryCms();
        }
        return (React.createElement(React.Fragment, null,
            this.displayZipEdit(),
            this.renderLoadingComponent(),
            this.state.zipEditOpen && this.displayZipEditField(),
            showModal && React.createElement(InsuranceModel_1.default, { data: showModal, checkout: false, cmscontent: {
                    moreInsuranceOptions: this.cmsContent.moreInsuranceOptions,
                    moreInsuranceOptionsLog: this.cmsContent.moreInsuranceOptionsLog,
                    zipChangeOKLabel: this.cmsContent.zipChangeOKLabel,
                } })));
    };
    CartZipEdit.prototype.mandateNonmandateCheck = function (linkDUrl) {
        var _a;
        var payload = Utils.getCartResp();
        var losgCont = Object.keys((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs);
        if (losgCont.length > 1) {
            linkDUrl = ReportingService_1.PageUrls.DS_Cart_Zipcode_Multiline_Modal;
        }
        return this.reportingService.fireZipCodeValidateEvent(false, '0', undefined, this.props.data.zipUpdateButtonContent, ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, linkDUrl);
    };
    CartZipEdit.prototype.displayZipEdit = function () {
        var _a, _b;
        var contentStyle = ((_a = this.props.data) === null || _a === void 0 ? void 0 : _a.isCommonCart) ? CartCommon_scss_1.commonContentSmall : '';
        var linkStyle = ((_b = this.props.data) === null || _b === void 0 ? void 0 : _b.isCommonCart) ?
            [CartCommon_scss_1.commonLinkSmall, localStyles.arrowSvgIcon].join(' ') : localStyles.zipLink;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: localStyles.zipDisplayMessage },
                React.createElement("span", { className: contentStyle },
                    this.props.data.zipDisplayContent,
                    ": "),
                this.props.data.isEditable ?
                    React.createElement(components_1.Link, { kind: "withAppendIcon", testId: utils_1.default('Cart', 'Zip', 'Edit'), onClick: this.toggleZipEdit, className: linkStyle, icon: this.state.zipEditOpen ?
                            React.createElement(components_1.IconSvg, { size: 24, svgNodeStr: Utils.GET_ICON_SVG.UP }) :
                            React.createElement(components_1.IconSvg, { size: 24, svgNodeStr: Utils.GET_ICON_SVG.DOWN }) }, this.props.data.zipCode)
                    :
                        React.createElement("span", null, this.props.data.zipCode))));
    };
    CartZipEdit.prototype.toggleZipEdit = function () {
        var _this = this;
        this.setState({ zipEditOpen: !this.state.zipEditOpen }, function () {
            _this.reportingService.fireLinkClickWithOutPageLoad(_this.state.zipEditOpen ?
                'zipCode edit open' : 'zipCode edit close', ReportingService_1.PageUrls.CART_PAGE);
            if (_this.state.zipEditOpen) {
                _this.setState({ zipCode: !_this.state.zipCode ?
                        _this.props.data.zipCode : _this.state.zipCode });
            }
        });
    };
    CartZipEdit.prototype.displayZipEditField = function () {
        var _this = this;
        return (React.createElement("div", { id: "zipEditBox", className: [CartConfiguration_scss_1.posRel, localStyles.enterZipCode,
                this.state.showZipErrorMsg ? CartConfiguration_scss_1.showErrMsg : ''].join(' ') },
            React.createElement(ui_components_1.TextField, { data: { input: this.state.zipCode }, testId: utils_1.default('TextField', 'ZipCode'), spi: true, options: {
                    maxLength: 5, type: TextFieldProps_1.TextFieldType.TEL,
                }, events: this.zipFieldEvents }),
            React.createElement(ui_components_1.Button, { data: {
                    disabled: !this.state.isZipCodeValid,
                    text: this.props.data.zipUpdateButtonContent,
                }, events: {
                    onClick: function () {
                        _this.submitZipCode(false);
                    },
                }, testId: utils_1.default('Button', 'updateZipCode'), options: { type: ButtonProps_1.ButtonType.SQUARE } }),
            this.state.showZipErrorMsg &&
                React.createElement("div", null,
                    React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartBadgealert].join(' '), role: "img", "aria-label": "Error", tabIndex: 0 }),
                    React.createElement("span", { "aria-live": "assertive", role: "alert" },
                        " ",
                        this.props.data.zipErrorContent)),
            React.createElement("div", { style: { clear: 'both' } })));
    };
    CartZipEdit.prototype.initializeZipCodeEvents = function () {
        var _this = this;
        this.zipFieldEvents = {
            onBlur: function (value) {
                if (value && value.length > 0) {
                    if (value.length !== 5
                        || !_this.NUM_ONLY_REGEX.test(value)) {
                        _this.setZipCodeValues(false, value);
                    }
                    else {
                        _this.setZipCodeValues(true, value);
                    }
                }
                else {
                    _this.setZipCodeValues(false, value);
                }
            },
            onChange: function (value) {
                if (value && value.currentTarget && value.currentTarget.value
                    && value.currentTarget.value.length === 5) {
                    _this.setZipCodeValues(true, value.currentTarget.value);
                    _this.setState({ showZipErrorMsg: false });
                }
                else {
                    _this.setZipCodeValues(false, value.currentTarget.value);
                }
            },
            onKeyPress: function (value, e) {
                if (!_this.NUM_ONLY_REGEX.test(e.key)) {
                    e.preventDefault();
                }
            },
        };
    };
    CartZipEdit.prototype.setZipCodeValues = function (isValid, value) {
        this.setState({
            isZipCodeValid: isValid,
            zipCode: value,
        });
    };
    CartZipEdit.prototype.renderLoadingComponent = function () {
        if (this.state.isLoading) {
            return (React.createElement("div", { className: localStyles.loaderShow },
                React.createElement(ui_components_1.InfiniteLoader, null)));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartZipEdit.prototype.submitZipCode = function (updateCookie) {
        var _this = this;
        this.setState({ isLoading: true });
        if (Utils.IsBsseFlow()) {
            this.api.validateZipCodeForBSSe(this.state.zipCode).then(function (response) {
                var _a, _b;
                _this.setState({ isLoading: false });
                if ((_b = (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.commonCart) {
                    var cartPayload = response.content.payload.commonCart;
                    var losgData = Object.values(cartPayload.losgs);
                    var taxZipCode_1;
                    losgData.forEach(function (losg) {
                        var _a;
                        taxZipCode_1 = (_a = losg === null || losg === void 0 ? void 0 : losg.losgTaxInfo) === null || _a === void 0 ? void 0 : _a.taxZipCode;
                    });
                    if (taxZipCode_1) {
                        _this.performZipCodeAction(false, '0');
                    }
                    else {
                        _this.performZipCodeAction(true, 'Invalid Zip', _this.props.data.zipErrorContent);
                    }
                }
                else {
                    _this.performZipCodeAction(true, 'Invalid Zip', _this.props.data.zipErrorContent);
                }
            }).catch(function (err) {
                _this.setState({ isLoading: false });
                _this.performZipCodeAction(true, 'System Down', _this.props.data.zipErrorContent);
            });
        }
        else {
            var zipCode = updateCookie ? this.props.data.zipCode : this.state.zipCode;
            this.api.validateZipCode(zipCode, updateCookie).then(function (response) {
                _this.setState({ isLoading: false });
                if (response && response.content && response.content.status && response.content.status.toUpperCase() === 'SUCCESS') {
                    if (response.content.payload.zipCodeChanged) {
                        _this.setState({ zipEditOpen: false, showZipErrorMsg: false });
                        _this.setState({ nonMandateToMandate: true });
                        var showModal = JSON.parse(sessionStorage.getItem('isMandateMsgShown'));
                        if (!showModal) {
                            _this.setState({ showInsuranceModal: true });
                            _this.mandateNonmandateCheck(ReportingService_1.PageUrls.DS_Cart_Zipcode_Mandate_Modal);
                            _this.reportingService.firePageLoadEvent(CartUtilFunctions_1.getLinkClickBaseUrlforNMDPR(), true);
                            _this.reportingService.fireZipCodeValidateEvent(false, '0', '0', _this.props.data.zipUpdateButtonContent, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, ReportingService_1.PageUrls.DS_Cart_Zipcode_Mandate_Modal);
                        }
                        else {
                            _this.mandateNonmandateCheck(ReportingService_1.PageUrls.DS_Cart_Zipcode_Mandate_Modal);
                            _this.performZipCodeAction(false, '0', '0', ReportingService_1.PageUrls.DS_Cart_Zipcode_Mandate_Modal);
                        }
                    }
                    else {
                        _this.mandateNonmandateCheck(ReportingService_1.PageUrls.DS_Cart_Zipcode_Non_Mandate_Modal);
                        _this.performZipCodeAction(false, '0', '0', ReportingService_1.PageUrls.DS_Cart_Zipcode_Non_Mandate_Modal);
                    }
                }
                else {
                    _this.performZipCodeAction(true, 'Invalid Zip', _this.props.data.zipErrorContent);
                }
            }).catch(function (err) {
                _this.setState({ isLoading: false });
                _this.performZipCodeAction(true, 'System Down', _this.props.data.zipErrorContent);
                _this.setState({ showZipErrorMsg: true });
            });
        }
    };
    CartZipEdit.prototype.performZipCodeAction = function (isFailure, errorMessage, errorContent, linkDesUrl) {
        if (linkDesUrl === void 0) { linkDesUrl = ReportingService_1.PageUrls.CART; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!isFailure) {
                    this.stateManager.set('cartUpdate', { cartRefresh: true });
                    this.setState({ zipEditOpen: false, showZipErrorMsg: false });
                }
                else {
                    this.setState({ showZipErrorMsg: true });
                }
                this.reportingService.fireZipCodeValidateEvent(isFailure, errorMessage, errorContent, this.props.data.zipUpdateButtonContent, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, linkDesUrl);
                return [2 /*return*/];
            });
        });
    };
    return CartZipEdit;
}(React.Component));
exports.default = CartZipEdit;
//# sourceMappingURL=CartZipEdit.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/CartZipEdit/CartZipEdit.js
// module id = 412
// module chunks = 8